let IframeModal = {
    render: async () => {
        let view =  /*html*/`
        <div id="iframe-modal" class="modal-window">
            <div class="modal-content">
                <a href="#" title="Close" class="modal-btn modal-close">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </a>
                <a href="#" title="Close" class="modal-btn modal-fullscreen">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-maximize"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>
                </a>

                <div class="modal-header" style="display: none;">
                    <h5 class="modal-heading"></h5>
                    <a href="#" title="Close" class="modal-close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </a>
                </div>
                <div class="modal-body">
                    <iframe src="data:text/html,<h1></h1>" id="gameIframe" frameborder="0" noresize="noresize" allow="geolocation 'self'; autoplay 'self'"></iframe>
                </div>
            </div>
        </div>
        `
        return view
    },
    after_render: async () => {
        var iframe = $('#iframe-modal');

        iframe.find('.modal-close').on('click', (e) => {
            e.preventDefault();
            IframeModal.hide();
        });

        iframe.find('.modal-fullscreen').on('click', (e) => {
            e.preventDefault();
            if(!$('#iframe-modal').hasClass('fullscreen')) {
                IframeModal.openFullscreen();
                $('#iframe-modal').addClass('fullscreen');
            } else {
                IframeModal.closeFullscreen();
                $('#iframe-modal').removeClass('fullscreen');
            }
        });
    },
    show: (title) => {
        $('#iframe-modal').find('.modal-heading').text(title);
        if (!$('#iframe-modal').hasClass('show')) $('#iframe-modal').addClass('show');
        if (!$('body').hasClass('modal-open')) $('body').addClass('modal-open');
        localStorage.setItem('isOnSlots', true);
        if (Tawk_API && Tawk_API.hideWidget) Tawk_API.hideWidget();
    },
    hide: () => {
        localStorage.setItem('isOnSlots', false);
        $('body').removeClass('modal-open');
        $('#iframe-modal').removeClass('show').find('.modal-body').html(`<iframe src="data:text/html,<h1></h1>" id="gameIframe" frameborder="0" noresize="noresize" allow="geolocation 'self'; autoplay 'self'"></iframe>`);
        if (Tawk_API && Tawk_API.showWidget) Tawk_API.showWidget();
    },
    loadIframe: async (url, enlarge) => {
        if ($('#iframe-modal').length === 0) {
            document.getElementById('iframe_container').innerHTML = await IframeModal.render();
            await IframeModal.after_render();
            if (enlarge === true) {
                $('#iframe-modal').addClass('enlarge');
            } else {
                $('#iframe-modal').removeClass('enlarge');
            }
            $('#gameIframe').attr('src', url);
            IframeModal.show();
        } else {
            $('#gameIframe').attr('src', url);
        }
    },
    openFullscreen: () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    },
    closeFullscreen: () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        }
    },
    openInNewTab: (href) => {
        $('#iframe_container').html(`<a href="${href}" target="_blank" rel="noopener noreferrer" id="gameIframeLink"></a>`);
        setTimeout(() => {
            document.getElementById('gameIframeLink').click();
        }, 150);
    }
}

export default IframeModal;
